import UIUAFeatureTable from 'ui-addon-upgrades/featureTable/FeatureTable';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import Products from 'merchandise-lib/constants/Product';
import { SingleSkeletonLoader } from '../../components/SingleSkeletonLoader';
import { FeatureTableHeaderCellContent } from '../../components/feature-table/FeatureTableHeaderCellContent';
import { BaseCardBadge } from '../../components/merch-card/BaseCardBadge';
import { PriceByProductApiName } from '../../containers/PriceByProductApiName';
import { PurchaseMotionContainer } from '../../containers/PurchaseMotionContainer';
import { useBadges } from '../../hooks/badges/useBadges';
import { useFormattedFeatureTableBodyData } from '../../hooks/features/useFormattedFeatureTableBodyData';
import { createFeatureTableHeaderTrackingData } from '../../utils/trackingData';
import { jsx as _jsx } from "react/jsx-runtime";
export const CommerceHubFeatureTable = () => {
  var _badges$Products$COMM, _badges$Products$COMM2;
  const formattedFeatureTableBodyData = useFormattedFeatureTableBodyData({
    productApiNames: [Products.COMMERCE_HUB_PROFESSIONAL, Products.COMMERCE_HUB_ENTERPRISE],
    skuCategoryName: 'COMMERCE_PRODUCTS'
  });
  const {
    badges
  } = useBadges({
    productApiNames: [Products.COMMERCE_HUB_PROFESSIONAL, Products.COMMERCE_HUB_ENTERPRISE]
  });
  if (formattedFeatureTableBodyData.error) {
    return null;
  }
  if (formattedFeatureTableBodyData.loading) {
    return /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 250,
      width: "100%"
    });
  }

  // If the fetch for data is successful and there are no features
  // don't render the table because the purchase motions are identical
  // to that of the merch card
  if (formattedFeatureTableBodyData.data.sectionData.all.features.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIUAFeatureTable, {
    canViewNewSeats: true,
    headerData: {
      [Products.COMMERCE_HUB_PROFESSIONAL]: {
        Content: /*#__PURE__*/_jsx(FeatureTableHeaderCellContent, {
          Badge: /*#__PURE__*/_jsx(BaseCardBadge, {
            apiName: Products.COMMERCE_HUB_PROFESSIONAL,
            badgeName: badges === null || badges === void 0 || (_badges$Products$COMM = badges[Products.COMMERCE_HUB_PROFESSIONAL]) === null || _badges$Products$COMM === void 0 ? void 0 : _badges$Products$COMM.badgeName
          }),
          ProductDisplayName: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "pricing-pages-ui.merchCardsV2.titleDisplay.professionalCard"
          }),
          Price: /*#__PURE__*/_jsx(PriceByProductApiName, {
            productApiName: Products.COMMERCE_HUB_PROFESSIONAL
          }),
          PurchaseMotion: /*#__PURE__*/_jsx(PurchaseMotionContainer, {
            productApiName: Products.COMMERCE_HUB_PROFESSIONAL,
            location: "MERCH_CARD",
            displayCount: 1,
            trackingData: createFeatureTableHeaderTrackingData(Products.COMMERCE_HUB_PROFESSIONAL, 'commerce')
          })
        })
      },
      [Products.COMMERCE_HUB_ENTERPRISE]: {
        Content: /*#__PURE__*/_jsx(FeatureTableHeaderCellContent, {
          Badge: /*#__PURE__*/_jsx(BaseCardBadge, {
            apiName: Products.COMMERCE_HUB_ENTERPRISE,
            badgeName: badges === null || badges === void 0 || (_badges$Products$COMM2 = badges[Products.COMMERCE_HUB_ENTERPRISE]) === null || _badges$Products$COMM2 === void 0 ? void 0 : _badges$Products$COMM2.badgeName
          }),
          ProductDisplayName: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "pricing-pages-ui.merchCardsV2.titleDisplay.enterpriseCard"
          }),
          Price: /*#__PURE__*/_jsx(PriceByProductApiName, {
            productApiName: Products.COMMERCE_HUB_ENTERPRISE
          }),
          PurchaseMotion: /*#__PURE__*/_jsx(PurchaseMotionContainer, {
            productApiName: Products.COMMERCE_HUB_ENTERPRISE,
            location: "MERCH_CARD",
            displayCount: 1,
            trackingData: createFeatureTableHeaderTrackingData(Products.COMMERCE_HUB_ENTERPRISE, 'commerce')
          })
        })
      }
    },
    bodyData: formattedFeatureTableBodyData.data,
    isInbound25PricingPage: true
  });
};